
<template>
  <transition name="fade">
    <div v-show="visible" class="overlay" :style="{ backgroundColor: background }" @click.self="handleClick">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0.5)',
    },
    clickClose: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
  },
  methods: {
    handleClick() {
      if (this.clickClose) {
        this.$emit('update:visible', false)
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
}
</script>

<style scoped>
.overlay {
  position: fixed;
  /* top: 0; */
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
